(function($)
{
    $.extend(true, orion, {
        api: {
            b2bApiKey: {}
        }
    });

    var
        api = orion.api.b2bApiKey,
        uri = '/api-authorization-key-de';

    function fetchApiKey(publicAccessId, timestamp)
    {
        var promise = $.ajax({
            url : uri + '/' + publicAccessId + '/' + timestamp,
            type: 'GET'
        });

        return promise;
    }

    api.fetchApiKey = fetchApiKey;
})(jQuery);
